<div class="notification-header">
    <mat-icon class="icon-style">info_outline</mat-icon>
    <p class="notification-header-text">{{"Please note, to make any changes to your profile, contact your youth worker" | translate}}.</p>
</div>

<!-- Back arrow for med screen size and up -->
<button
    mat-button
    class="back-to-profile"
    routerLink="/profile"
>
<mat-icon class="icon">arrow_back</mat-icon>
{{"Back" | translate}}
</button>

<!-- X button for mobile views -->
<button
    mat-button
    class="close-profile"
    routerLink="/profile"
>
<mat-icon class="icon" aria-label="close button">close</mat-icon>
</button>

<main class="container">
    <h1 class="header-title">{{ "My Profile" | translate }}</h1>
    <p class="subheader-title">{{ "Thank you for creating your student profile. Watch out for new features coming soon!" | translate}}</p>

    <div class="profile-sections" *ngIf="studentProfile">
        
        <app-student-profile-card [studentProfile]="studentProfile"></app-student-profile-card>

        <mat-divider></mat-divider>

        <mat-accordion class="panel-style" #panel hideToggle>
            <mat-expansion-panel
                (opened)="panelOpenState = true"
                (closed)="panelOpenState = false"
            >
                <mat-expansion-panel-header [collapsedHeight]="'64px'" [expandedHeight]="'64px'">
                    <mat-panel-title class="header-title" style="font-size: 20px">
                        {{ "Additional Information" | translate }}
                    </mat-panel-title>

                    <mat-panel-description fxLayoutAlign="end" class="green-text" style="font-weight: 500">
                        <mat-icon *ngIf="!panelOpenState" class="expandIcon">expand_more</mat-icon>
                        <mat-icon *ngIf="panelOpenState" class="expandIcon">expand_less</mat-icon>
                        {{panelOpenState ? _translator.instant('Show Less') : _translator.instant('Show More')}}
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <div class="information-section" *ngIf="panelOpenState">
                    <app-student-profile-card-additional-info [studentProfile]="studentProfile" [_references]="_references"></app-student-profile-card-additional-info>
                  </div>

            </mat-expansion-panel>

        </mat-accordion>

    </div>

</main>
